<template>
	<div>
		<!-- order -->
		<tour-order/>
		<tour-order-details-agency/>
		<tour-order-details-client/>
		<tour-order-pipeline/>
		<tour-order-status/>
		<tour-time-ticket-release-note/>
		<tour-qr-code/>
		<tour-job-offer/>
		<tour-new-navigation/>
	</div>
</template>

<script setup lang="ts">
import TourRegisterSetupService from '@/setup/tour/TourRegisterSetupService';
import TourOrder from '@/components/tour/TourOrder.vue';
import TourOrderDetailsAgency from '@/components/tour/TourOrderDetailsAgency.vue';
import TourOrderDetailsClient from '@/components/tour/TourOrderDetailsClient.vue';
import TourOrderPipeline from '@/components/tour/TourOrderPipeline.vue';
import TourOrderStatus from '@/components/tour/TourOrderStatus.vue';
import TourTimeTicketReleaseNote from '@/components/tour/TourTimeTicketReleaseNote.vue';
import TourQrCode from '@/components/tour/TourQrCode.vue';
import TourJobOffer from '@/components/tour/TourJobOffer.vue';
import TourNewNavigation from '@/components/tour/TourNewNavigation.vue';
const setup = new TourRegisterSetupService();
</script>
